import React from "react";
import { injectIntl } from "react-intl";
import { Modal } from "@ebsco-ui/ebsco-ui";
import sharedMessages from "../../../../shared-messages";
import GdprPrompt from "../../gdpr-prompt";

import "./data-retention-modal.scss";
const block = "data-retention-modal";

const DataRetentionModal = ({ intl: { formatMessage }, isOpen, onClose }) => {
  const setAppElement = () => {
    if (process.env.NODE_ENV !== "test") return "#root";
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      modalTitle={formatMessage(sharedMessages.personalDataRetentionAndUsage)}
      className={block}
      appElement={setAppElement()}
    >
      <Modal.Header
        className={`${block}__header`}
        closeButtonProps={{
          title: formatMessage(sharedMessages.close),
          onClick: onClose
        }}
      />
      <Modal.Body className={`${block}__body`}>
        <GdprPrompt />
      </Modal.Body>
    </Modal>
  );
};

export { DataRetentionModal };
export default injectIntl(DataRetentionModal);
